export default __webpack_public_path__ + "static/media/Terminator's Mantle of the Living Legend.ddaf2b74.jpg";